<template>
	<div class="events-header">
		<div class="h-full" :class="[ container ? 'events-container' : 'pl-25 pr-25' ]">
			<div class="flex justify-between items-center h-full">
				<div class="flex items-center">
					<nuxt-link v-if="permissions.isVerifiedAdmin" class="d-inline-block pl-10" to="/profile/my-pixellot/">
						<img alt="logo" class="logo" src="/my/images/pixellot-logo-white.png" width="120" height="15">
					</nuxt-link>
					<div v-else class="d-inline-block pl-10">
						<img alt="logo" class="logo" src="/my/images/pixellot-logo-white.png" width="120" height="15">
					</div>
					<transition-group mode="out-in" name="list" tag="div">
						<nuxt-link
							v-if="permissions.isAuthenticated && $route.name == 'events-view'"
							key="videos"
							class="pl-10 font-uppercase"
							:to="{ name: 'events-index-videos' }"
						>
							{{ $tc('events.tabs.videosLabel') }}
						</nuxt-link>
						<nuxt-link
							v-if="permissions.isAuthenticated && $route.name == 'events-view'"
							key="teams"
							class="pl-10 font-uppercase"
							:to="{ name: 'events-index-teams' }"
						>
							{{ $tc('events.tabs.teamsLabel') }}
						</nuxt-link>
					</transition-group>
				</div>
				<div class="selector-wrapper">
					<LanguageSelector class="ml-35" />
				</div>
				<user-menu v-if="permissions.isAuthenticated" />
				<div v-else-if="!isAuthRoute">
					<nuxt-link class="pl-25 font-uppercase" :to="{ name: 'auth-index-login', query: { redirectTo: $route.fullPath } }">
						{{ $tc('components.authHeader.signIn') }}
					</nuxt-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserMenu from '~/components/events/UserMenu'
import LanguageSelector from '~/components/interface/LanguageSelector'

export default {
	name: 'EventsHeader',
	components: { UserMenu, LanguageSelector },
	props: {
		container: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		...mapGetters({ permissions: 'user/permissions' }),

		isAuthRoute () {
			return this.$route.name === 'auth-index-login' || this.$route.name === 'auth-index-sign-up'
		}
	}
}
</script>

<style lang="scss">
	.events-header {
		position: fixed;
		z-index: 100;
		top: 0;
		left: 0;
		height: $headerHeight;
		width: 100%;
		font-size: 12px;

		&::before {
			content: '';
			@include full-absolute(-2);
			background-image: linear-gradient(62deg, #171a1b 0%, #342798 53%, #7e008d);
		}

		&::after {
			content: '';
			@include full-absolute(-1);
			background-color: rgba(33, 33, 33, 0.3);
		}

		a {
			color: #a5d6ed;
		}

		.selector-wrapper {
			margin-right: auto;
			.language-drawer {
				@include respond-below(phone) {
					right: -75px;
				}
			}
		}
	}
</style>
